import { z } from "zod";
import { ImageSourceSchema } from "./image";
import { IsoDateString } from "./isoDate";

export const FileBase = z.object({
    id: z.string(),
    uploaded: IsoDateString,
    name: z.string().nullish(),
    displayName: z.string().nullish(),
    description: z.string().nullish(),
    sizeBytes: z.number().nullish(),
    type: z.string().nullish(),
    aiDescriptionShort: z.string().nullish(),
    aiDescriptionLong: z.string().nullish(),
    aiDescriptionStatus: z.enum(["PENDING", "DONE", "ERROR"]).nullish(),
    aiOptOut: z.boolean().nullish(),
    /**
     * PRTL-1497: the viewer may turn this file's AI transcript on or off (they
     * uploaded it, in the org they're acting as). Absent means no: the toggle hides.
     */
    canManageAI: z.boolean().optional(),
});

export const PublicFile = FileBase.extend({
    visibility: z.literal("public"),
    url: z.string(), // CDN URL — use directly
    /** PRTL-1349: sized WebP copies, when the file is an image that has them. */
    image: ImageSourceSchema.optional(),
});

export const PrivateFile = FileBase.extend({
    visibility: z.literal("private"),
    // No url — must call getDownloadUrl
});

export const FileEntry = z.discriminatedUnion("visibility", [PublicFile, PrivateFile]);

/** @deprecated Use FileEntry instead */
export const Document = FileBase;
